class StickyComponent
{
    constructor($wrapper, $fixed)
    {
        this.$header = $('header');
        this.$wrapper = $wrapper;
        this.$wrapperFixed = $fixed;
    }

    recalculate()
    {
        const scroll = $(window).scrollTop();
        const offset = this.$wrapper.offset().top;
        const headerHeight = this.$header.outerHeight();
        const wrapperHeight = this.$wrapper.outerHeight();
        const wrapperFixedHeight = this.$wrapperFixed.outerHeight();
        const wrapperFixedMargin = 20;

        if ((scroll + headerHeight + wrapperFixedMargin) > offset) {
            if ((scroll + headerHeight + wrapperFixedHeight) > (offset + wrapperHeight - (2 * wrapperFixedMargin))) {
                this.$wrapperFixed.css('margin-top', (wrapperHeight - wrapperFixedHeight - wrapperFixedMargin) + 'px');
                this.$wrapperFixed.removeClass('sticky');
            } else {
                this.$wrapperFixed.css('margin-top', '0px');
                this.$wrapperFixed.addClass('sticky');
                this.$wrapperFixed.css('top', (headerHeight + wrapperFixedMargin) + 'px');
            }
        } else {
            this.$wrapperFixed.removeClass('sticky');
        }
    }

    events()
    {
        $(window).scroll(() => {
            if (this.isAccessible()) {
                this.recalculate();
            }
        });
        $(window).resize(() => {
            if (this.isAccessible()) {
                this.recalculate();
            }
        });
    }

    isAccessible()
    {
        return (this.$wrapper.length && this.$wrapper.is(':visible'));
    }

    init()
    {
        this.events();
        if (this.isAccessible()) {
            this.recalculate();
        }
    }
}

export default StickyComponent;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/components/sticky-component.js